import { render } from "./InfoSection.vue?vue&type=template&id=444664ea&scoped=true&ts=true"
import script from "./InfoSection.vue?vue&type=script&lang=ts"
export * from "./InfoSection.vue?vue&type=script&lang=ts"

import "./InfoSection.vue?vue&type=style&index=0&id=444664ea&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a1-CI\\_work\\151\\s\\src\\MagnetoEnergy.Vue.WebClient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444664ea"]])

export default __exports__